import * as React from "react";
import {Col, Row} from "react-bootstrap";

const FacilityPage : React.FC = () => {
    return (
        <div className={"facility"}>
            <div>
                <img src={"/images/header_facility.png"} className={"header"} alt={"宮岡クリニック 設備のご案内 - 通院で直せる痔の治療 宮岡クリニックでは、専門性を生かし、胃、大腸、肛門の治療に特に力を注いでいます。"}/>
            </div>
            <h1>
                コロナウイルス対策に関して
            </h1>
            <Row>
                <Col className={"image"}>
                    <img src={"/images/reception.jpg"} className={"fit"}/>
                </Col>
            </Row>
            <Row>
                <Col>
                    <p>
                        当院ではコロナウイルスの対策として十分な換気、ウイルス吸着可能な空気清浄機の設置、パーテーションの設置を行っております。
                        各部署に消毒液を設置しております。
                    </p>
                    <p>
                        マスク着用の上、ご来院ください。
                    </p>
                    <p>
                        当院受診歴の有無に関わらず、発熱患者様の受け入れを行っています。
                    </p>
                </Col>
            </Row>
            <h1>
                内視鏡室および手術室
            </h1>
            <Row>
                <Col xs={12} md={6} className={"image"}>
                    <img src={"/images/operating_room.jpg"}/>
                </Col>
                <Col xs={12} md={6}>
                    <ul>
                        <li>胃カメラ</li>
                        <li>大腸内視鏡検査</li>
                        <li>ポリープの切除</li>
                    </ul>
                    <p>
                        ガンの早期発見や、ポリープの切除を行います。<br/>
                        （過去一万人以上の検査を実施しております。）<br/>
                        胃・大腸内視鏡検査時には鎮静剤を使用し苦痛のない検査・治療を行っております。<br/>
                        胃カメラは通常の経口からの内視鏡の他、<a href={"/scope.html"} className={"normal"}>極細径スコープ</a>による経鼻内視鏡もおこなっております。<br/>
                        専用の内視鏡洗浄器で清潔かつ安全な検査、治療を行っています。<br/>
                    </p>
                    <p>
                        <strong>当院は<a href={"https://www.coloproctology.gr.jp/"} target={"_blank"} className={"normal"}>日本大腸肛門病学会</a>の認定施設です。</strong>
                    </p>
                </Col>
            </Row>
            <h1>
                腹部エコー
            </h1>
            <Row>
                <Col xs={12} md={6} className={"image"}>
                    <img src={"/images/echo.jpg"}/>
                </Col>
                <Col xs={12} md={6}>
                    <p>
                        肝臓、胆のう、腎臓、などの検査を行います。<br/>
                        お腹にゼリーを塗るだけで、まったく苦痛はありません。
                    </p>
                </Col>
            </Row>
            <h1>
                レントゲン室
            </h1>
            <Row>
                <Col xs={12} md={6} className={"image"}>
                    <img src={"/images/roentgen.jpg"}/>
                </Col>
                <Col xs={12} md={6}>
                    <ul>
                        <li>胸部・腹部レントゲン</li>
                        <li>骨・関節レントゲン</li>
                        <li>骨塩定量検査（骨密度測定）</li>
                    </ul>
                </Col>
            </Row>
        </div>
    );
}

export default FacilityPage;
